export const MAX_LOGIN_ATTEMPTS_STATUS = 405;

export class RequestMethod {
  static GET = 'GET';
  static POST = 'POST';
  static PUT = 'PUT';
  static PATCH = 'PATCH';
  static DELETE = 'DELETE';
  static HEAD = 'HEAD';

  static isPost(method: string) {
    return method === RequestMethod.POST;
  }

  static isPutOrPatch(method: string) {
    return method === RequestMethod.PUT || method === RequestMethod.PATCH;
  }

  static isDelete(method: string) {
    return method === RequestMethod.DELETE;
  }
}
